import script from "./method-question.vue?vue&type=script&setup=true&lang=ts"
export * from "./method-question.vue?vue&type=script&setup=true&lang=ts"

import "./method-question.vue?vue&type=style&index=0&id=7b8e5e46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b8e5e46"]])

export default __exports__